import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  sv: require('./lang/sv.json'),
};

const i18n = new VueI18n({
  locale: 'sv',
  messages,
});

export default i18n;
